import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';
import { InvoiceTask } from '@/hooks/api/models';

type Props = {
  children: ReactNode;
};

export type InvoiceTaskContextType = {
  invoiceTask?: InvoiceTask;
  setInvoiceTask: Dispatch<SetStateAction<InvoiceTask | undefined>>;
}

const InvoiceTaskContext = createContext<InvoiceTaskContextType>({
  invoiceTask: undefined,
  setInvoiceTask: () => {
  }
});

export const InvoiceTaskProvider = ({ children }: Props) => {
  const [invoiceTask, setInvoiceTask] = useState<InvoiceTask>();

  return (
    <InvoiceTaskContext.Provider value={{ invoiceTask, setInvoiceTask }}>
      {children}
    </InvoiceTaskContext.Provider>
  );
};

export const useCurrentInvoiceTask = () => {
  return useContext(InvoiceTaskContext);
};
